export default "__VITE_ASSET__BVNttZSI__"